import {FiMenu} from 'react-icons/fi';
import styles   from './styles/MobileHeader.module.scss';
import {useContext} from "react";
import {EmployeeContext} from "./context/EmployeeContext.jsx";


export default function MobileHeader({onBurgerClick}) {
    const { employee } = useContext(EmployeeContext);
    const name = employee?.name || 'admin';
    return (
        <header className={styles.mobileHeader}>
            <span>{name}</span>
            <FiMenu className={styles.burger} onClick={onBurgerClick}/>
        </header>
    );
}
